import toast from "react-hot-toast";
import usePut from "../put/usePut";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { COMPANY_ID, COMPANYNAME, NAME, ROLE, TOKEN_NAME, COMPANY_EMPLOYEE_ID, IS_LIVE_TRACKING, IS_CHAT, IS_HRMS } from "../../config";
import { throwError } from "../../utility/errorHandler";

const cookies = new Cookies();
const useBasicLogin = () => {
  let navigate = useNavigate();
  
  const { handleAuth: loginUser } = usePut({
    url: "login_user",
    onSuccess: (res) => {
      toast.success("Login Successfully");
      const { token, role, company_id, company_name, name, company_employee_id, access_type } = res?.data?.data
      
      cookies.set(TOKEN_NAME, token, { path: "/" });
      cookies.set(ROLE, role, { path: "/" });
      cookies.set(NAME, name, { path: "/" });
      cookies.set(COMPANY_ID, company_id, { path: "/" });
      cookies.set(COMPANYNAME, company_name, { path: "/" });
      cookies.set(COMPANY_EMPLOYEE_ID, company_employee_id, { path: "/" });
      
      // Set access type cookies
      cookies.set(IS_LIVE_TRACKING, access_type?.is_live_tracking, { path: "/" });
      cookies.set(IS_CHAT, access_type?.is_chat, { path: "/" });
      cookies.set(IS_HRMS, access_type?.is_hrms, { path: "/" });
      
      navigate("/", { replace: true });
    },
    onError: (err) => {
      if (err.response.status === 400) {
        toast.error("Email and/or password incorrect");
      } else {
        throwError(err);
      }
    },
  });

  const handleLoginUser = (data) => {
    loginUser.mutate(data);
  };

  return { loginUser, handleLoginUser };
};

export default useBasicLogin;